// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { useTranslation } from "react-i18next";
import FormField from "../../../components/FormField";
import { NewsFormSectionProps } from "../../../types/NewsTypes";
import { FIELD_LENGTH } from "../../../../utils/Constant";
import "moment/locale/fr";

const NewsContentInputFormSection: React.FunctionComponent<NewsFormSectionProps> = (
  props: NewsFormSectionProps
) => {
  const { t } = useTranslation();

  const { editMode, previewFields, setPreviewFields, showRequired } = props;

  return (
    <>
      <FormField
        textArea={true}
        labelName={t("add_news.summary.text")}
        inputId="summary"
        required={showRequired}
        placeholder={t("add_news.summary.placeholder")}
        fieldClassName={!editMode ? "readonly-textarea" : ""}
        emptyErrorMessage={t("global.empty_error_field")}
        readOnly={!editMode}
        onChange={e =>
          setPreviewFields({
            ...previewFields,
            summary: e.target.value
          })
        }
        maxLength={FIELD_LENGTH.TEXTAREA}
        minRows={6}
      />
    </>
  );
};

NewsContentInputFormSection.defaultProps = {
  editMode: true,
  showRequired: true
};

export default NewsContentInputFormSection;
